'use strict';

var React = require('react');

var SvgOrganizationMajor = function SvgOrganizationMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5 5h2v2h-2v-2Zm2 3h-2v2h2v-2Zm-2 3h2v2h-2v-2Zm6-6h-2v2h2v-2Zm-2 3h2v2h-2v-2Zm2 3h-2v2h2v-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 19a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3h3a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-9v-3h-2v3h-5Zm1-2v-14h10v14h-2v-1a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v1h-2Zm13-2h-1v-2h1v2Zm0-4h-1v-2h1v2Z"
  }));
};

exports.SvgOrganizationMajor = SvgOrganizationMajor;
